import type { SportProfile } from '@/types'

export const iceHockey: SportProfile = {
  id: 'ice-hockey',
  sport: 'ice-hockey',
  gender: 'coed',
  environment: 'indoor',
  label: 'Ice Hockey',
  emoji: '🏒',
  playersOnField: 6,
  contactLevel: 'full',
  hasShotClock: false,
  periods: { label: 'Period', count: 3, durationMinutes: 20 },
  positions: [
    { key: 'goalie',       label: 'Goalie',        shortLabel: 'G',  maxOnField: 1 },
    { key: 'left_defense', label: 'Left Defense',  shortLabel: 'LD' },
    { key: 'right_defense',label: 'Right Defense', shortLabel: 'RD' },
    { key: 'left_wing',    label: 'Left Wing',     shortLabel: 'LW' },
    { key: 'center',       label: 'Center',        shortLabel: 'C'  },
    { key: 'right_wing',   label: 'Right Wing',    shortLabel: 'RW' },
  ],
  stats: [
    { key: 'goal',               label: 'Goal',                shortLabel: 'G'   },
    { key: 'assist',             label: 'Assist',               shortLabel: 'A'   },
    { key: 'shot',               label: 'Shot',                 shortLabel: 'SH'  },
    { key: 'shot_on_goal',       label: 'Shot on Goal',         shortLabel: 'SOG' },
    { key: 'save',               label: 'Save',                 shortLabel: 'SV'  },
    { key: 'faceoff_win',        label: 'Faceoff Win',          shortLabel: 'FOW', statType: 'faceoff-win' },
    { key: 'faceoff_loss',       label: 'Faceoff Loss',         shortLabel: 'FOL', statType: 'faceoff-loss' },
    { key: 'power_play_goal',    label: 'Power Play Goal',      shortLabel: 'PPG' },
    { key: 'shorthanded_goal',   label: 'Shorthanded Goal',     shortLabel: 'SHG' },
    { key: 'penalty_minor',      label: 'Minor Penalty',        shortLabel: 'MIN', statType: 'card' },
    { key: 'penalty_major',      label: 'Major Penalty',        shortLabel: 'MAJ', statType: 'card' },
    { key: 'hit',                label: 'Hit',                  shortLabel: 'HIT' },
    { key: 'blocked_shot',       label: 'Blocked Shot',         shortLabel: 'BS'  },
    { key: 'opp_shot',           label: 'Opp Shot',             shortLabel: 'OPP', statType: 'opp-shot' },
  ],
}
